import React from "react";
import Hero from "../../components/medical/Hero";
import LeadershipTeam from "../../components/LeadershipTeam";
import HighlightedContactSection from "../../components/HighlightedContactSection";

const SALES_TEAM_TITLE = "Lernen Sie unser Vertriebsteam kennen";

export default function SalesTeamPage() {
  return (
    <>
      <Hero title="Team" subheading="Die Menschen hinter REPEXO Sales." />
      <div className="min-h-screen bg-white">
        <div id="section-team">
          <LeadershipTeam
          variant="page"
          teamPagePath="/sales/team"
          sectionTitle={SALES_TEAM_TITLE}
          />
        </div>
        <HighlightedContactSection
          heading="Sprechen Sie mit unserem Team"
          description="Sie möchten die richtigen Ansprechpartner für Ihr Anliegen? Wir verbinden Sie gerne."
          buttonText="Jetzt Kontakt aufnehmen"
          sectionId="section-team-contact"
        />
      </div>
    </>
  );
}
